import { Component, OnInit } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';

export interface PopUpModel {
  title: string;
  Item: any;
}

@Component({
  selector: 'app-list-report',
  templateUrl: './list-report.component.html',
  styleUrls: ['./list-report.component.css']
})

export class ListReportComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  title: string;
  Item: any;
  data: any = []

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    this.data = this.Item;
  }

}
